import { RouterProvider } from 'react-router-dom'
import { useState } from 'react'

import { AppProviders } from './providers'
import { createRouter } from './router'

export function App() {
  const [router] = useState(createRouter)

  return (
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  )
}

export default App
